"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.rectContainsPoint = rectContainsPoint;
exports.callAfterNextAnimationFrame = callAfterNextAnimationFrame;
exports.isChild = isChild;
exports.getWrapperElement = getWrapperElement;

function rectContainsPoint(rect, point) {
  return point.clientX > rect.left && point.clientX < rect.right && point.clientY < rect.bottom && point.clientY > rect.top;
}
/**
 * Used to delay a function until the pending animation frame has drawn
 *
 * An example of usage is when an element's display: none is removed, it cannot be transitioned
 * that frame. The change to opacity for example must be done after the element has rendered
 * with a display other than none. If a transitioned property is changed while display is none,
 * the browser will skip the transition and set the property to the final value. This is
 * most likely an optimization that concluded the transition was pointless since the element wasn't
 * visible anyway.
 */


function callAfterNextAnimationFrame(cb, n) {
  // requestAnimationFrame undefined, call the callback in 30ms
  if (!window.requestAnimationFrame) {
    return window.setTimeout(function () {
      return cb();
    }, 30);
  }

  if (n === 2) {
    return cb();
  } else {
    return window.requestAnimationFrame(function () {
      return callAfterNextAnimationFrame(cb, n ? n + 1 : 1);
    });
  }
}

function isChild(potentialChild, parent) {
  if (potentialChild === parent) {
    return true;
  }

  if (!potentialChild.parentElement) {
    return false;
  }

  return isChild(potentialChild.parentElement, parent);
}

function hasClass(el, cls) {
  return el.getAttribute('class') && el.getAttribute('class').split(' ').indexOf(cls) >= 0;
}

function findAncestor(givenEl, cls) {
  var el = givenEl; // IE11 does not support classlist on svg elements

  while (el && !hasClass(el, cls)) {
    el = el.parentElement;
  }

  return el;
}
/**
 * Find the nearest wrapper element for the given node.
 */


function getWrapperElement(node) {
  return findAncestor(node, 'zsg-tooltip-viewport') || document.getElementsByTagName('body')[0];
}


//////////////////
// WEBPACK FOOTER
// ./~/@zillow/react-zsg/util/launcherBase.js
// module id = 202
// module chunks = 0